export const CONSENT_STORAGE_KEY = "justicedrive_cookie_consent";
export const CONSENT_VERSION = 1;

export type ConsentPreferences = {
  necessary: true;
  analytics: boolean;
  advertising: boolean;
  version: number;
  updatedAt: string;
};

export type ConsentCategory = "analytics" | "advertising";

export type GoogleConsentValue = "granted" | "denied";

export type GoogleConsentState = {
  analytics_storage: GoogleConsentValue;
  ad_storage: GoogleConsentValue;
  ad_user_data: GoogleConsentValue;
  ad_personalization: GoogleConsentValue;
};

export type MicrosoftConsentState = {
  ad_storage: GoogleConsentValue;
};
